/* Pages ROOK Partners : chiffres animés, simulateur de gains, formulaires de contact Shopify.
   SEO : le HTML contient déjà les valeurs finales ; l'animation ne démarre qu'à l'écran et retombe sur la même valeur. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (v, dec, sep) => {
    let s = v.toFixed(dec).replace('.', ',');
    if (sep || v >= 1000) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s;
  };
  const tween = (el, to, dec = 0, d = 1200) => {
    if (reduce) { el.textContent = fmt(to, dec); return; }
    const from = 0, t0 = performance.now();
    const step = t => { const p = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(from + (to - from) * e, dec, el.dataset.sep); if (p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };

  // Compteurs : de 0 à la valeur écrite, une fois, quand le chiffre arrive à l'écran
  const counters = document.querySelectorAll('[data-rp-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; const el = e.target; tween(el, +el.dataset.rpCount, +(el.dataset.dec || 0)); io.unobserve(el); }), { threshold: .7 });
    counters.forEach(c => io.observe(c));
  }

  // Simulateur : objectif en euros → pots à vendre
  const root = document.querySelector('.rp--deal');
  const sim = document.querySelector('[data-rp-sim]');
  if (root && sim) {
    // Gain par pot en centimes, calculé par Shopify à partir du prix affiché (aucun prix écrit sur la page)
    const c20 = +root.dataset.rpC20, c30 = +root.dataset.rpC30;
    const range = sim.querySelector('[data-rp-goal]'), out = sim.querySelector('[data-rp-goal-out]');
    const pots = sim.querySelector('[data-rp-pots]'), week = sim.querySelector('[data-rp-week]'), day = sim.querySelector('[data-rp-day]');
    const dots = sim.querySelector('[data-rp-dots]'), ref = sim.querySelector('[data-rp-ref]'), chips = sim.querySelectorAll('[data-rp-chip]');
    const MAX = 200;
    let last = null;
    const draw = n => {
      const shown = Math.min(n, MAX);
      dots.innerHTML = Array.from({ length: shown }, (_, i) => `<i style="--i:${i % 60}"></i>`).join('') + (n > MAX ? `<i class="is-more" title="+${n - MAX}"></i>` : '');
    };
    const update = animate => {
      const goal = +range.value, per = (ref.checked ? c30 : c20) / 100;
      const n = Math.ceil(goal / per);
      out.textContent = fmt(goal, 0, goal >= 1000);
      range.style.setProperty('--p', ((goal - range.min) / (range.max - range.min) * 100) + '%');
      chips.forEach(c => c.classList.toggle('is-on', +c.dataset.rpChip === goal));
      if (animate && last !== null) tween(pots, n, 0, 500); else pots.textContent = n;
      week.textContent = fmt(Math.ceil(n / 4.33), 0);
      day.textContent = fmt(Math.round(n / 30 * 10) / 10, n / 30 >= 10 ? 0 : 1);
      if (n !== last) draw(n);
      last = n;
    };
    range.addEventListener('input', () => update(false));
    range.addEventListener('change', () => update(false));
    ref.addEventListener('change', () => update(true));
    chips.forEach(c => c.addEventListener('click', () => { range.value = c.dataset.rpChip; update(true); }));
    // Premier dessin quand le simulateur arrive à l'écran
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { update(false); tween(pots, +pots.textContent || 33, 0, 900); io.disconnect(); } }, { threshold: .35 });
      io.observe(sim);
    } else update(false);
  }

  // Réseau : ?r=tiktok|insta|both dans le lien du DM, sinon dernier choix, sinon « les deux »
  const netRoot = document.querySelector('[data-rp-net-root]');
  if (netRoot) {
    const btns = netRoot.querySelectorAll('[data-rp-net]');
    const form = netRoot.querySelector('[data-rp-nets]') && netRoot.querySelector('[data-rp-nets]').closest('form');
    const box = n => form.querySelector(`[data-net=${n}]`);
    const syncForm = () => form && form.querySelectorAll('[data-rp-handle]').forEach(h => {
      const on = box(h.dataset.rpHandle).checked;
      h.hidden = !on; h.querySelector('input').required = on;
    });
    const setNet = (n, save) => {
      if (!['tiktok', 'insta', 'both'].includes(n)) n = 'both';
      netRoot.dataset.net = n;
      btns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rpNet === n)));
      if (form) { box('tiktok').checked = n !== 'insta'; box('instagram').checked = n !== 'tiktok'; syncForm(); }
      if (save) try { localStorage.setItem('rok-rp-net', n); } catch (e) {}
    };
    const q = new URLSearchParams(location.search).get('r');
    let saved = null; try { saved = localStorage.getItem('rok-rp-net'); } catch (e) {}
    setNet(q === 'instagram' ? 'insta' : (q || saved || 'both'), !!q);
    btns.forEach(b => b.addEventListener('click', () => setNet(b.dataset.rpNet, true)));
    form && form.querySelectorAll('[data-rp-nets] input').forEach(i => i.addEventListener('change', syncForm));
  }

  // Après envoi réussi : le message « Reçu » est mis à l'écran
  const done = document.querySelector('[data-rp-done]');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

  // Formulaires (contact natif Shopify) : contrôle des champs, horodatage de l'acceptation, puis envoi normal
  const MSG = { accept: 'Coche l’accord pour rejoindre.', adult: 'Le programme est réservé aux majeurs dont la résidence fiscale est en France.', zip: 'Code postal français à 5 chiffres.', nets: 'Coche au moins un réseau.', email: 'Email invalide.' };
  document.querySelectorAll('form.rp-form').forEach(f => {
    const msg = f.querySelector('[data-rp-msg]');
    if (!msg) return;
    f.querySelectorAll('[data-rp-up]').forEach(i => i.addEventListener('input', () => { i.value = i.value.toUpperCase().replace(/[^A-Z0-9-]/g, ''); }));
    f.addEventListener('submit', e => {
      f.querySelectorAll('.is-err').forEach(x => x.classList.remove('is-err'));
      const bad = [...f.querySelectorAll('input[required]')].filter(i => i.type === 'radio' ? !f.querySelector(`input[name="${i.name}"]:checked`) : i.type === 'checkbox' ? !i.checked : !i.value.trim() || (i.type === 'email' && !/^\S+@\S+\.\S+$/.test(i.value)));
      const nets = f.querySelector('[data-rp-nets]');
      if (nets && !nets.querySelector('input:checked')) bad.unshift(nets.querySelector('input'));
      const zip = f.querySelector('[data-rp-err=zip]');
      if (zip && zip.value && !/^\d{5}$/.test(zip.value.trim())) bad.push(zip);
      if (bad.length) {
        e.preventDefault();
        bad.forEach(i => (i.closest('.rp-pick,.rp-field,.rp-check') || i).classList.add('is-err'));
        const k = bad[0].dataset.rpErr;
        msg.textContent = (k && (k !== 'email' || bad[0].value.trim()) && MSG[k]) || 'Il manque une info. Les champs signalés sont à remplir.';
        bad[0].focus();
        return;
      }
      // Preuve : date et heure de l'envoi (heure du téléphone, avec fuseau) ; l'email Shopify porte aussi sa propre date
      const d = new Date(), z = -d.getTimezoneOffset(), pad = n => String(Math.abs(n)).padStart(2, '0');
      const stamp = f.querySelector('[data-rp-stamp]');
      if (stamp) stamp.value = d.toLocaleString('fr-FR', { dateStyle: 'long', timeStyle: 'medium' }) + ` (UTC${z >= 0 ? '+' : '-'}${pad(Math.trunc(z / 60))}:${pad(z % 60)})`;
      // Retour après envoi : même adresse exacte (paramètres compris), avec la confirmation
      const back = f.querySelector('input[name=return_to]');
      if (back) { const u = new URL(location.href); u.searchParams.set('contact_posted', 'true'); u.hash = f.id; back.value = u.pathname + u.search + u.hash; }
      const out = f.querySelector('[data-rp-nets-out]');
      if (out) out.value = [...f.querySelectorAll('[data-net]:checked')].map(i => i.dataset.net === 'tiktok' ? 'TikTok' : 'Instagram').join(' + ');
      // Pas de bouton bloqué : Shopify peut afficher un captcha, que la personne peut fermer
      msg.textContent = '';
    });
  });
})();
